<section class="containerProd">
    <button [ngClass]="category.catbreakfast" (click)="selectcatBreakfast()">Desayunos</button>
    <button [ngClass]="category.catRest" (click)="selectcatRest()">Almuerzo / Cena</button>
</section>
